import { render, staticRenderFns } from "./ConfigDirectMatchCepProperties.vue?vue&type=template&id=719a29f8&scoped=true&"
import script from "./ConfigDirectMatchCepProperties.vue?vue&type=script&lang=js&"
export * from "./ConfigDirectMatchCepProperties.vue?vue&type=script&lang=js&"
import style0 from "./ConfigDirectMatchCepProperties.vue?vue&type=style&index=0&id=719a29f8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719a29f8",
  null
  
)

export default component.exports